import React from 'react';
import { Stack, Select, MenuItem, InputLabel, Typography, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FamilyPackTicket } from '../../../domain/tickets';
import { useIsMobile } from '../../../hooks';
import { useFamilyTicketPassengers } from '../hooks/use-ticket-type';

interface Props {
  value: FamilyPackTicket;
  onChange: (familyPackTicket: FamilyPackTicket) => void;
}

export const FamilyPackTicketsSelect = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { familyPackTickets } = useFamilyTicketPassengers();

  const handleTicketTypeChange = (event) => {
    onChange(event.target.value);
  };

  const mobileSx = { width: '100%' };
  const desktopSx = { display: 'flex', flex: 1 };

  return (
    <FormControl sx={isMobile ? mobileSx : desktopSx}>
      <InputLabel id="ticket-type-selector-label" sx={{ color: '#6C6D70' }}>
        {t('ticket_type')}
      </InputLabel>
      <Select
        id="ticket-type-selector"
        label={t('ticket_type')}
        value={value}
        labelId="ticket-type-selector-label"
        onChange={handleTicketTypeChange}
      >
        {familyPackTickets.map(({ label, passengers }) => (
          <MenuItem key={passengers} value={passengers}>
            <Stack width="100%" direction="row" justifyContent="space-between">
              <Typography variant="body2">{label}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
